import { TSystemSettingValueCommon, TSystemSettingValueCommonResponse } from './system-setting-value.type';
import { adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export type TSystemSettingCalendarEventColorBirthday = TSystemSettingValueCommon & {
  value?: number;
};

export type TSystemSettingCalendarEventColorBirthdayResponse = TSystemSettingValueCommonResponse & {
  value?: number;
};

export type TSystemSettingCalendarEventColorBirthdayPayload = {
	value?: number;
};

export type TSystemSettingCalendarEventColorBirthdayRequest = {
	value?: number;
};

export function adaptSystemSettingCalendarEventColorBirthdayFromResponse(data: TSystemSettingCalendarEventColorBirthdayResponse): TSystemSettingCalendarEventColorBirthday {
	const {
		public_id: publicId,
		name,
		value,
		description,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		publicId,
		name,
		value,
		description,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptSystemSettingCalendarEventColorBirthdayToRequest(data: TSystemSettingCalendarEventColorBirthdayPayload): TSystemSettingCalendarEventColorBirthdayRequest {
	const { value = '' } = data;

	return {
		value: value ? value : undefined,
	};
}
